import axios from 'axios';

const url = 'https://socialstudents-backend.herokuapp.com/posts'||"http://localhost:5000/posts";

export const fetchPosts = () => axios.get(url);
export const createPost = (newPost) => axios.post(url, newPost);
